import { render, staticRenderFns } from "./SurveyAnalysis.vue?vue&type=template&id=60fd08fa&scoped=true&"
import script from "./SurveyAnalysis.vue?vue&type=script&lang=js&"
export * from "./SurveyAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./SurveyAnalysis.vue?vue&type=style&index=0&id=60fd08fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fd08fa",
  null
  
)

/* custom blocks */
import block0 from "./SurveyAnalysis.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60fd08fa')) {
      api.createRecord('60fd08fa', component.options)
    } else {
      api.reload('60fd08fa', component.options)
    }
    module.hot.accept("./SurveyAnalysis.vue?vue&type=template&id=60fd08fa&scoped=true&", function () {
      api.rerender('60fd08fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/SurveyAnalysis.vue"
export default component.exports